





































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import Transaccion from "@/models/tarjeta/transaccion.model";
import TipoTramite from "@/models/tipoTramite";
import TramiteTransaccionNoAutorizadaModel, {
  TransaccionNoAutorizadaModel
} from "@/models/tramite/reclamo/transaccion-no-autorizada.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import Helpers from "@/helpers/helper";
import BTableConfig from '@/core/BTableConfig/BTableConfig';
@Component
export default class ConsumoNoAutorizado extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;
  @Prop() readonly title!: string;

  model: TransaccionNoAutorizadaModel;
  constructor() {
    super();
    this.model = new TransaccionNoAutorizadaModel();
  }
 onUpdateTransaccionTable(config: BTableConfig<Transaccion>) {
    config.checkable = true;
    config.checking.check = this.onCheck;
  }

  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }

  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }

  created() {
    let props = [];
    props.push(new TipoTramiteComponentProp("title", "string", true, "Título"));
    this.$emit("render", props);
  }

  @Watch("model", { deep: true })
  set(model: TransaccionNoAutorizadaModel) {
    if (this.content) {
      let contenido = this.content as any;
      contenido.descripcionReclamo = model.descripcion;
      contenido.telefonoReclamo = Helpers.Filters.PhoneToStr(model.telefono);
      contenido.tramiteTransaccionesNoAutorizadas = model.transacciones;
      this.$emit("update:content", contenido);
    }
  }
  onCheck(trasacciones: Transaccion[], selected: Transaccion) {
    this.model.transacciones = trasacciones.map(
      x => new TramiteTransaccionNoAutorizadaModel(x.id)
    );
  }

  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.tramiteTransaccionesNoAutorizadas) {
        delete contenido.descripcionReclamo;
        delete contenido.telefonoReclamo;
        delete contenido.tramiteTransaccionesNoAutorizadas;
      }
      this.$emit("update:content", contenido);
    }
  }


}
